import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { Map, List } from 'immutable';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, reset, touch, focus } from 'redux-form';

import { Button } from 'semantic-ui-react';

import * as shareLib from 'libs/shareLib';
import * as shareActions from 'modules/share';

import { ServiceShareAddUser } from 'components';

const reduxFormName = 'shareAddUser';
class CtServiceShareAddUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onProgress: false,
      disabledProgress: false,
      aModal: false,
      errorMessage: ''
    };
  }

  componentWillReceiveProps(nextProps) {
    const { invalid } = this.props;
    const { formStore } = nextProps;

    if (formStore && formStore.fields) {
      const errorType = ['syncErrors', 'syncWarnings', 'asyncErrors', 'asyncWarnings'];

      let anyError = false;
      for (const field in formStore.fields) {
        if (
          formStore.fields.hasOwnProperty(field) &&
          formStore.fields[field].touched &&
          formStore.fields[field].visited &&
          formStore.registeredFields[field] &&
          formStore.registeredFields[field].count > 0
        ) {
          for (let i = 0, l = errorType.length; i < l; i++) {
            if (formStore[errorType[i]] && formStore[errorType[i]][field]) {
              anyError = true;
              this.setState({ disabledProgress: true });
              break;
            }
          }
        }
        if (anyError) {
          break;
        }
      }

      if (!anyError) {
        this.setState({ disabledProgress: false });
      }
    }
  }

  markFieldValidate = formName => {
    const { dispatch, formStore } = this.props;

    if (formStore && formStore.registeredFields) {
      for (const field in formStore.registeredFields) {
        if (formStore.registeredFields.hasOwnProperty(field)) {
          if (formStore.registeredFields[field].count > 0) {
            dispatch(focus(formName, field));
            dispatch(touch(formName, field));
          }
        }
      }
    }
  };

  mountAModal = () => {
    const { aModal } = this.state;
    const { dispatch } = this.props;

    if (aModal) {
      // 열려진 경우로 닫는다.
      dispatch(reset(reduxFormName));
      this.setState({
        onProgress: false,
        disabledProgress: false,
        aModal: false
      });
    } else {
      // 닫혀진 경우로 연다.
      this.setState({ aModal: true, errorMessage: '' });
    }
  };

  prepareProgress = () => {
    if (this.props.invalid) {
      this.markFieldValidate(reduxFormName);
    } else {
      this.addShareUser();
    }
  };

  handleOnKeyUp = () => {
    this.setState({ errorMessage: '' });
  };

  addShareUser = async () => {
    this.setState({ onProgress: true });

    if (!this.props.invalid) {
      // 국제화 처리
      const { formatMessage } = this.props.intl;
      const { formStore, invalid, userEmail } = this.props;

      const params = {};
      if (formStore && formStore.values && formStore.values.shareUserEmail) {
        params.shareUserEmail = formStore.values.shareUserEmail;
      }

      let isOk = true;
      let errorMessage = '';
      if (Object.keys(params).length > 0) {
        //
      } else {
        // 오류
        isOk = false;
      }

      if (params.shareUserEmail === userEmail) {
        errorMessage = defineMessages(
          formatMessage({
            id: 'CtServiceShareAddUser_2',
            defaultMessage: '내 이메일입니다. (다른 사용자를 입력하세요)'
          })
        );
      }

      if (isOk) {
        try {
          const { ShareActions } = this.props;
          const respObj = await ShareActions.addShareUser(params);
          if (respObj && respObj.status && respObj.status === 200 && respObj.data) {
            // 성공
            if (!!respObj.data.list) {
              // 새로고침
              ShareActions.reloadShare();
              this.mountAModal();
              // 서비스 넘버 에러
            } else if (!!respObj.data.error && !!respObj.data.error[0].errInfo) {
              if (respObj.data.error[0].errInfo === 'User Not Exist') {
                errorMessage = defineMessages(formatMessage({ id: 'Target_15', defaultMessage: '대상자가 없습니다' }));
              } else if (respObj.data.error[0].errInfo === 'Duplicate User Exist') {
                errorMessage = defineMessages(
                  formatMessage({ id: 'vali_22', defaultMessage: '이미 등록된 이메일입니다.' })
                );
              } else {
                errorMessage = respObj.data.error[0].errInfo;
              }
            }
          } else {
            // 응답 오류
            console.log('실패');
          }
        } catch (e) {
          console.log(e);
        }
      } else {
        console.log('addShareUser isOk fail!');
      }

      this.setState({ errorMessage: errorMessage, onProgress: false });
    } else {
      this.markFieldValidate(reduxFormName);
    }
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { onProgress, disabledProgress, aModal, errorMessage } = this.state;
    const { invalid, formStore, isAuth, shareInfo } = this.props;
    const { mountAModal, prepareProgress, handleOnKeyUp } = this;

    return (
      <div className="bt-share-user-add">
        <Button
          className="bt-style-gleam common-button-brand"
          size="tiny"
          content={defineMessages(formatMessage({ id: 'CtServiceShareAddUser_1', defaultMessage: '공유 사용자 추가' }))}
          onClick={mountAModal}
          color="blue"
        />
        {aModal && (
          <ServiceShareAddUser
            onProgress={onProgress}
            disabledProgress={disabledProgress}
            invalid={invalid}
            formStore={formStore}
            isAuth={isAuth}
            prepareProgress={prepareProgress}
            handleOnToggleAModal={mountAModal}
            errorMessage={errorMessage}
            handleOnKeyUp={handleOnKeyUp}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    formStore: state.form[reduxFormName],
    isAuth: state.user.get('isAuth'),
    userEmail: state.user.get('user').userEmail
  };
};

const mapDispatchToProps = dispatch => ({
  ShareActions: bindActionCreators(shareActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: reduxFormName,
    touchOnChange: true
  })(injectIntl(CtServiceShareAddUser))
);



// WEBPACK FOOTER //
// ./src/script/containers/share/CtServiceShareAddUser.js